import styled from 'styled-components'

export const StyledSelectFooter = styled.div`
  ${({ theme }) => `
    padding: ${theme.spacing.s} ${theme.spacing.m};
    color: ${theme.semantic.contentPrimary};
    border-top: 1px solid ${theme.semantic.borderSubtle};
  `}
`
